import styled from "styled-components"

export const Container = styled.div`
  margin-left: 4rem;
`;

export const ContainerSales = styled.div`
  width: 100%;
  

  .filter-container{
    margin-top: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .radio-container{
      display: flex;
      align-items: center;

      label{
        margin-left: 5px;
        color: #4A007A;
      }

      .radio{
        appearance: none;
        width: 15px;
        height: 15px;
        border-radius: 100%;
        border: 2px solid #4A007A;;
        outline: none;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        &:before{
          content: '';
          position: absolute;
          height: 10px;
          width: 10px;
          border-radius: 100%;
          background: #4A007A;;
          opacity: 0;
        }

        &:checked:before{
          opacity: 1;
        }
      }
    }
  }
`;


